// Smibha Luxe Candles — house fragrance library.
// Every candle can be hand-poured in any of these signature scents.
// Notes follow the classic top → middle → dry-down structure.

export const FRAGRANCE_PROFILES = [
  {
    key: "sandalwood-vanilla",
    name: "Sandalwood Vanilla",
    description:
      "An opulent, velvety embrace that utterly redefines warmth. It transforms classic sweetness into an immersive, rich ritual designed for candlelit evenings and quiet indulgence.",
    top: "Bitter Orange, Delicate Peony, Crisp Bergamot",
    middle: "Sensual Vanilla Orchid, Warm Tonka, Ethereal Lily",
    dry: "Architectural Cedarwood, Creamy Mysore Sandalwood, Deep Vanilla Accord",
  },
  {
    key: "ocean-breeze",
    name: "Ocean Breeze",
    description:
      "An airy, sun-drenched escape capturing the raw, revitalizing energy of a secluded coastal retreat. It fills the room with the crystalline purity of crashing waves and salt-kissed skin.",
    top: "Sun-Ripened Orange Zest, Crushed Grapefruit, Velvet Peach Skin",
    middle: "Dewy Water Lily, Luminous Neroli, Crisp Marine Cucumber Vine",
    dry: "Bleached Driftwood Sandalwood, Wild Sea Moss, Clean Sheer Musk",
  },
  {
    key: "cinnamon-bourbon",
    name: "Cinnamon Bourbon",
    description:
      "Deep, spirited, and intoxicatingly cozy. This blend pairs the smoky complexity of top-shelf, oak-aged bourbon with a sharp, elegant cloud of dark kitchen spice.",
    top: "Sharp Ceylon Cinnamon, Aged Small-Batch Bourbon",
    middle: "Rich Bourbon Vanilla, Grated Nutmeg, Bruised Clove",
    dry: "Charred Oak Barrels, Warm Brown Sugar, Crystallized Amber",
  },
  {
    key: "fierce",
    name: "Fierce",
    description:
      "A bold, striking, and unforgettably modern composition. It features a crisp mineral edge that asserts itself with a brilliant, unapologetic presence.",
    top: "Pressed Amalfi Lemon, Sun-Kissed Bergamot, Mineral Water Accord",
    middle: "Honeyed Orange Blossom, English Lavender, Wild White Thyme",
    dry: "Structured Teakwood, Sheer Black Leather, Warm Skin Musk",
  },
  {
    key: "apple-cider",
    name: "Apple Cider",
    description:
      "A highly refined, poetic interpretation of a nostalgic staple. It perfectly distills the dense, steaming aroma of slow-simmered heritage orchard cider and dark winter spices.",
    top: "Pressed Heirloom Apple Cider",
    middle: "Whole Cinnamon Stick, Ground Clove, Warm Nutmeg",
    dry: "Sweet Madagascar Vanilla, Golden Amber, Smoked Cedar",
  },
  {
    key: "christmas-lights",
    name: "Christmas Lights",
    description:
      "A sparkling, nostalgic celebration of festive light and seasonal joy. This fragrance blends bright winter citruses with a baseline of pure sugary magic, instantly illuminating the spirit of a home.",
    top: "Cold Orange Zest, Frosted Lemon Zest, Crisp Red Apple, Sweet Pineapple",
    middle: "Tart Cranberry Marmalade Accord, Macerated Winter Cherry",
    dry: "Wild Raspberry Bramble, Melted Sugarcane",
  },
  {
    key: "fresh-orange",
    name: "Fresh Orange",
    description:
      "A bright, sun-warmed burst of freshly peeled citrus that instantly lifts the whole room. It settles into a clean, gently sweet glow that feels effortlessly uplifting and refreshing.",
    top: "Fresh Orange, Orange Peel, Sweet Citrus",
    middle: "Mandarin, Light Florals, Citrus Blossom",
    dry: "Soft Musk, Clean Woods, Smooth Citrus Finish",
  },
  {
    key: "jasmine",
    name: "Jasmine",
    description:
      "An elegant, true-to-life floral that unfurls like a garden at dusk. Luminous white petals rest on a soft, woody base for a scent that is both romantic and quietly sophisticated.",
    top: "Bergamot, Mandarin, Pear",
    middle: "Star Jasmine, White Rose, Lily of the Valley",
    dry: "Cedar, Amber, Musk",
  },
  {
    key: "lime",
    name: "Lime",
    description:
      "A crisp, zesty rush of freshly cut lime that awakens the senses. Green citrus brightness melts into smooth woods for a clean, invigorating finish.",
    top: "Bergamot, Kaffir Lime, Lemon Zest",
    middle: "Jasmine, Citron, Green Notes",
    dry: "Limewood, White Musk, Sandalwood",
  },
  {
    key: "apple-white-cedar",
    name: "Apple & White Cedar",
    description:
      "A juicy, orchard-fresh apple wrapped in soft, creamy woods. Ripe fruit and delicate florals settle into a smooth, sweet cedar base for cozy, wholesome warmth.",
    top: "Red Delicious Apple, Luscious Melon, Peach Skin",
    middle: "Green Grass, Crushed Clove, Jasmine Petals",
    dry: "White Cedar, Sandalwood, Creamy Vanilla, Sugar, Musk",
  },
  {
    key: "by-the-fireplace",
    name: "By the Fireplace",
    description:
      "A rich, spiced retreat that captures the crackle and glow of a winter hearth. Warm woods, dark spice and smooth musk wrap the room in deep, grounding comfort.",
    top: "Blue Rosemary, Orange Peel, Wild Raspberry",
    middle: "Clove Bud, Ground Cinnamon",
    dry: "Patchouli, Blonde Cedar, Indian Sandalwood, Cashmere Musk",
  },
  {
    key: "fresh-lavender",
    name: "Fresh Lavender",
    description:
      "A calming, herbaceous escape drawn straight from a sun-drenched lavender field. Cool eucalyptus and true French lavender rest on soft musk for a serene, restful mood.",
    top: "Silver Leaf Eucalyptus, Bergamot",
    middle: "French Lavender, Wild Fern",
    dry: "Patchouli, Sheer Musk",
  },
  {
    key: "strawberry-swirl",
    name: "Strawberry Swirl",
    description:
      "A playful, mouth-watering swirl of ripe summer berries and sweet cream. Juicy strawberries and cherries fold into whipped vanilla for a joyful, dessert-like delight.",
    top: "Monterey Strawberry, Pineapple, Peach Nectar",
    middle: "Autumn Bliss Raspberry, Bing Cherry",
    dry: "Spun Sugar, Whipped Vanilla",
  },
  {
    key: "coffee",
    name: "Coffee",
    description:
      "A rich, roasted embrace for true coffee lovers. Freshly ground beans melt into buttery caramel and milky vanilla for a warm, indulgent café-at-home ritual.",
    top: "Roasted Coffee Beans",
    middle: "Hint of Maple",
    dry: "Buttery Caramel, Milky Vanilla",
  },
  {
    key: "unscented",
    name: "Unscented",
    isUnscented: true,
    description:
      "No fragrance added — a pure, scent-free candle. The same hand-poured wax and clean cotton wick, with a soft, natural glow for those who prefer a fragrance-free space.",
    top: "None",
    middle: "None",
    dry: "None",
  },
];

export const DEFAULT_FRAGRANCE_KEY = FRAGRANCE_PROFILES[0].key;

export function getFragrance(key) {
  return FRAGRANCE_PROFILES.find((p) => p.key === key) || FRAGRANCE_PROFILES[0];
}
